import React from 'react';
import { IconButton } from '@material-ui/core';
import { mdiMagnifyMinusOutline, mdiMagnifyPlusOutline } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../lib/';
const MagnifyButtons = styled.div `
    display: flex;
    justify-content: center;

    svg {
        color: ${(props) => props.theme.colors.primary};
        width: ${IconSize.Medium};
        height: ${IconSize.Medium};
    }
`;
const Magnifier = ({ zoomOut, zoomIn }) => {
    return (React.createElement(MagnifyButtons, null,
        React.createElement(IconButton, { onClick: zoomOut, "aria-label": "Zoom out" },
            React.createElement(Icon, { path: mdiMagnifyMinusOutline })),
        React.createElement(IconButton, { onClick: zoomIn, "aria-label": "Zoom in" },
            React.createElement(Icon, { path: mdiMagnifyPlusOutline }))));
};
export default Magnifier;
//# sourceMappingURL=index.js.map